module.exports = __webpack_public_path__ + "img/MapThumb_HillFort.b431f797.webp";